if (!window.dAgency) window.dAgency = {};
window.dAgency.initLowEnergyBar = (context) => {
  const lowEnergyBarSection = context.closest('.low-energy-bar__main-wrapper');
  if (!lowEnergyBarSection) return;

  const body = document.querySelector('body');

  document.querySelector('.low-energy-bar__switch__toggle input').addEventListener('change', () => {
    if (body.classList.contains('force-dark-theme')) {
      body.classList.remove('force-dark-theme');

      // Reset layers' style
      document.querySelectorAll('.low-energy-layer').forEach(layer => {
        layer.attributeStyleMap.delete('display');
      })

      document.querySelectorAll('video').forEach(video => {
        video.play()
      })

    } else {
      body.classList.add('force-dark-theme');

      document.querySelectorAll('video').forEach(video => {
        video.pause()
      })
    }
  });

  document.querySelectorAll('.low-energy-image-layer button').forEach(button => {
    button.addEventListener('click', () => {
      button.closest('.low-energy-image-layer').style.display = 'none';
    })
  })

  document.querySelectorAll('.low-energy-video-layer button').forEach(button => {
    button.addEventListener('click', () => {
      button.closest('.low-energy-video-layer').style.display = 'none';
      let currentSection = button.closest('.shopify-section');

      currentSection.querySelectorAll('video').forEach(video => {
        video.play();
      })
    })
  })

}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.low-energy-bar__container'), (el) => {
    window.dAgency.initLowEnergyBar(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.low-energy-bar__container'), (el) => {
      window.dAgency.initLowEnergyBar(el);
    });
  });
}
